export const isSafari = (userAgent: string) =>
  /^((?!chrome|android).)*safari/i.test(userAgent);
